var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "form",
    attrs: {
      model: _vm.form,
      "label-col": {
        span: 4
      },
      "wrapper-col": {
        span: 15
      },
      rules: _vm.ruleData
    }
  }, [_c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("新增方式"),
      prop: "addWay"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.form.addWay,
      callback: function ($$v) {
        _vm.$set(_vm.form, "addWay", $$v);
      },
      expression: "form.addWay"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "HAND_MOVEMENT"
    }
  }, [_vm._v(_vm._s(_vm.$t("手动添加")))])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("字段名称"),
      prop: "name"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("字段名称"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("字段分类"),
      prop: "field_category"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("字段分类"),
      disabled: _vm.$route.params.id != -1
    },
    on: {
      change: e => _vm.getTemplateSelectOption(e)
    },
    model: {
      value: _vm.form.field_category,
      callback: function ($$v) {
        _vm.$set(_vm.form, "field_category", $$v);
      },
      expression: "form.field_category"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "insurance_template"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("投保模板")) + " ")]), _c("a-select-option", {
    attrs: {
      value: "claims_param"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("理赔参数")) + " ")])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_vm.form.field_category === "insurance_template" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("模板类型"),
      prop: "type"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("模板类型")
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, _vm._l(_vm.typeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1) : _vm._e()], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("标识"),
      prop: "code"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("标识"),
      disabled: _vm.$route.params.id != -1,
      allowClear: ""
    },
    model: {
      value: _vm.form.code,
      callback: function ($$v) {
        _vm.$set(_vm.form, "code", $$v);
      },
      expression: "form.code"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("提示文字"),
      prop: "description"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("提示文字"),
      allowClear: ""
    },
    model: {
      value: _vm.form.description,
      callback: function ($$v) {
        _vm.$set(_vm.form, "description", $$v);
      },
      expression: "form.description"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注"),
      prop: "remark"
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("备注"),
      allowClear: ""
    },
    model: {
      value: _vm.form.remark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "remark", $$v);
      },
      expression: "form.remark"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("控件"),
      prop: "display"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("控件"),
      disabled: _vm.$route.params.id != -1
    },
    on: {
      change: _vm.displayChange
    },
    model: {
      value: _vm.form.display,
      callback: function ($$v) {
        _vm.$set(_vm.form, "display", $$v);
      },
      expression: "form.display"
    }
  }, _vm._l(_vm.displaysOptionData, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_vm._v(_vm._s(_vm.$t(item.label)))]);
  }), 1)], 1)], 1), _vm.form.display === "SINGLE_ROW" || _vm.form.display === "MULTILINE" ? _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    key: "lengthLimit",
    attrs: {
      label: _vm.$t("长度限制"),
      prop: "lengthLimit"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      precision: 0,
      parser: value => value.replace(/[^\d]/g, ""),
      placeholder: _vm.$t("请输入") + _vm.$t("长度限制")
    },
    model: {
      value: _vm.form.lengthLimit,
      callback: function ($$v) {
        _vm.$set(_vm.form, "lengthLimit", $$v);
      },
      expression: "form.lengthLimit"
    }
  })], 1)], 1) : _vm._e(), _vm.form.display === "SELECT" ? _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    key: "displayType",
    attrs: {
      label: _vm.$t("控件类型"),
      prop: "displayType"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.form.displayType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "displayType", $$v);
      },
      expression: "form.displayType"
    }
  }, [_c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("省市区(三级)")))]), _c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("省市(两级)")))]), _c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "6"
    }
  }, [_vm._v(_vm._s(_vm.$t("省(一级)")))]), _c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("证件类型")) + " ")]), _c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "5"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("行业")) + " ")]), _c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "7"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("职业分类")) + " ")]), _c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "8"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("区域银行")) + " ")]), _c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("自定义")) + " ")])], 1)], 1)], 1) : _vm._e(), _vm.form.display === "TIME" ? _c("a-col", {
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    key: "formatStyle",
    attrs: {
      label: _vm.$t("格式"),
      prop: "formatStyle"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.form.formatStyle,
      callback: function ($$v) {
        _vm.$set(_vm.form, "formatStyle", $$v);
      },
      expression: "form.formatStyle"
    }
  }, [_c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("年-月-日")))]), _c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("年-月-日 时:分:秒")))])], 1)], 1)], 1) : _vm._e(), _vm.form.display === "IMG" ? _c("a-col", {
    key: "other",
    attrs: {
      span: 24
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("其他"),
      prop: "other"
    }
  }, [_c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "1"
    },
    model: {
      value: _vm.form.other,
      callback: function ($$v) {
        _vm.$set(_vm.form, "other", $$v);
      },
      expression: "form.other"
    }
  }, [_vm._v(_vm._s(_vm.$t("支持上传多张")))])], 1)], 1) : _vm._e()], 1), _c("a-col", {
    staticClass: "btnBox",
    attrs: {
      span: 24
    }
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "add",
      loading: _vm.loading
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))]), _vm.$route.params.id == -1 ? _c("a-checkbox", {
    attrs: {
      checked: _vm.continueState
    },
    on: {
      change: function ($event) {
        _vm.continueState = !_vm.continueState;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("继续添加")) + " ")]) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };